<script setup lang="ts">
import { UiButton, UiText } from "@shopexperts/shared";

defineProps<{
    title: string;
    isLoading: boolean;
    error: unknown;
    onRetry?: () => void | Promise<void>;
}>();
</script>

<template>
    <main class="flex-1 p-4 md:p-8 overflow-y-auto bg-secondary font-light w-full">
        <h1 class="text-h1 font-bold mb-8">{{ title }}</h1>

        <slot name="persistent" />

        <div v-if="isLoading" class="flex justify-center items-center py-20">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>

        <div v-else-if="error" class="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
            <UiText variant="p" as="p" class="text-red-800 font-semibold mb-2">
                Failed to load profile
            </UiText>
            <UiText variant="p-small" as="p" class="text-red-600 mb-4">
                {{ (error as Error).message || "An error occurred while fetching your profile" }}
            </UiText>
            <UiButton
                v-if="onRetry"
                variant="outline"
                label="Try Again"
                @click="onRetry"
            />
        </div>

        <template v-else>
            <slot />
        </template>
    </main>
</template>
